import React from "react";
import PropTypes from "prop-types";
import { Card, CardBody, Col, Row } from "reactstrap";

const Widget = (props) => {
  const widget = [
    {
      id: 1,
      title: "Ingresos diarios",
      count: props.data.daily_income.toLocaleString("es-CO"),
      icon: "mdi mdi-cash-multiple text-primary",
      color: "success",
      dollor: true,
    },
    {
      id: 2,
      title: "Cuentas por cobrar",
      count: props.data.daily_debts.toLocaleString("es-CO"),
      icon: "mdi mdi-account-cash-outline text-danger",
      color: "danger",
      dollor: true,
    },
    {
      id: 3,
      title: "Cantidad del día",
      count: `${props.data.daily_animals} Bovinos`,
      icon: "mdi mdi-cow mdi-lg text-primary",
      color: "success",
      dollor: false,
    },
    {
      id: 4,
      title: "Recorridos del día",
      count: props.data.daily_tours,
      icon: "mdi mdi-car-pickup text-success",
      color: "warning",
      dollor: false,
    },
    {
      id: 5,
      title: "Balance diario",
      count: props.data.daily_balance.toLocaleString("es-CO"),
      icon: "bx bx-chart text-info", //bx bxs-bank text-secondary
      color: "warning",
      dollor: true,
    },
    {
      id: 6,
      title: "Ingreso en efectivo",
      count: props.data.cash.toLocaleString("es-CO"),
      icon: "mdi mdi-cash-multiple text-success",
      color: "warning",
      dollor: true,
    },
    {
      id: 7,
      title: "Ingreso en bancos",
      count: props.data.bank.toLocaleString("es-CO"),
      icon: "bx bxs-bank text-secondary text-success",
      color: "warning",
      dollor: true,
    },
  ];

  return (
    <React.Fragment>
      <Row>
        {widget.map((widget, key) => (
          <Col md={4} xl={3} key={key}>
            <Card>
              <CardBody>
                <div className="float-end">
                  <div className="avatar-sm mx-auto mb-4">
                    <span className="avatar-title rounded-circle bg-light font-size-24">
                      <i className={widget.icon}></i>
                    </span>
                  </div>
                </div>
                <div>
                  <p className="text-muted text-uppercase fw-semibold sm">
                    {widget.title}
                  </p>
                  <h5 className="mb-1 mt-1">
                    {widget.dollor === true ? "$ " : ""}
                    <span className="counter-value" data-target="58425">
                      {widget.count}
                    </span>
                  </h5>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </React.Fragment>
  );
};

Widget.propTypes = {
  data: PropTypes.object,
};

export default Widget;
